import {Component, OnInit} from '@angular/core';
import {AdvantageModel} from '../../models/advantageModel';
import {MarketingItemService} from '../../service/marketing-item.service';
import {MarketingItemModel} from '../../models/marketing-item.model';
import {MarketingItemsModel} from '../../models/marketing-items.model';

@Component({
  selector: 'app-adventages-section',
  templateUrl: './advantages-section.component.html',
  styleUrls: ['./advantages-section.component.scss']
})
export class AdvantagesSectionComponent implements OnInit {

  classes = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eight', 'ninth', 'tenth', 'eleven', 'twelve'];
  marketingItems: MarketingItemModel[] = [];

  constructor(private marketingService: MarketingItemService) {

    this.marketingService.getMarketingItemItems().subscribe((marketingItems: MarketingItemModel[]) => {
      this.marketingItems = marketingItems;
    });
  }

  ngOnInit() {
  }

}
